import FoulingConfigData from "./data";

export default function mapFoulingConfigData(json) {
    return new FoulingConfigData(
        json.foulingMethod,
        json.foulingAdjusted
    );
} 